namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmKombinacePostSluzeb extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmKombinacePostSluzebReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmKombinacePostSluzebObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmKombinacePostSluzebObj());
            this.detailObj.createBase({
                contentName: "detailAdmKombinacePostSluzeb",
                contentCaption: "jres:33000233", //RC 33000191 : Druh zásilky
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push({
                    tabParams: {
                        id: "tab-funkce",
                        title: "jres:33000263",
                        opened: true,
                        locked: true,
                        group: { id: "_tab-funkce" },
                        menuBar: [
                            {
                                action: this.actions.actAddFunkce,
                                favorite: true,
                            },
                            {
                                action: this.actions.actEditFunkce,
                                favorite: true,
                            }
                        ]
                    },
                    init: (tab) => { this.detailObj.createPovFunkceTab(tab) }
                })
                tabs.push({
                    tabParams: {
                        id: "tab-spis-uzel",
                        title: "jres:33000264",
                        opened: true,
                        locked: true,
                        group: { id: "_tab-spis-uzel" },
                        menuBar: [
                            {
                                action: this.actions.actAddSpisUzel,
                                favorite: true,
                            },
                            {
                                action: this.actions.actEditSpisUzly,
                                favorite: true,
                            }
                        ]   
                    },
                    init: (tab) => { this.detailObj.createPovSpisUzlyTab(tab) }
                })
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            this.detailObj.setSpecialGroups(groups);
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmKombinacePostSluzeb", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmKombinacePostSluzebObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmKombinacePostSluzebReadDto> {
        private gridFunkce: JQuery<HTMLElement>;
        private gridSpisUzly: JQuery<HTMLElement>;
        private groupFunkce: IGTabGroupOptions;
        private groupSpisUzel: IGTabGroupOptions;

        create() {
            console.log(this.data)
        }

        textPopis(): string | undefined | null {
            return this.data["komb_sluzeb_txt_txt"]
        }

        setSxsDetail(): string {
            return (this.data.komb_sluzeb) ? this.data.komb_sluzeb : "";
        }

        setSpecialGroups(groups: IGTabGroupOptions[]) {
            this.groupFunkce = {
                id: "_tab-funkce",
                caption: "jres:33000263", //RC 33000263 : Navázané funkce
                visible: this.data.vycet_uzel_funkce == 1
            };
            this.groupSpisUzel = {
                id: "_tab-spis-uzel",
                caption: "jres:33000264", //RC 33000264 : Navázané spis. uzly
                visible: this.data.vycet_uzel_funkce == 1
            };
            if (this.options.newRecord == false) {
                groups.push(this.groupFunkce);
                groups.push(this.groupSpisUzel);
            }
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmKombinacePostSluzebSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (this.options.newRecord == false) {
                data.povolene_funkce = this.gridFunkce.ggrid("getView").getDataRows(false, "data");
                data.povolene_spis_uzly = this.gridSpisUzly.ggrid("getView").getDataRows(false, "data");
            } else {
                data.povolene_funkce = [];
                data.povolene_spis_uzly = [];
            }
            (this.cnt.isl.AdmKombinacePostSluzeb.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmKombinacePostSluzeb", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmKombinacePostSluzeb.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.komb_sluzeb_txt) ? this.data.komb_sluzeb_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actAddFunkce: {
                    caption: "jres:33000248", //RC 33000248 : Přidat
                    icon: "gi-plus",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.funkceForm();
                    }
                },
                actEditFunkce: {
                    caption: "jres:32000120",
                    icon: "gi-pencil",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.editFunkce();
                    }
                },
                actAddFunkceOK: {
                    caption: "jres:33000243",
                    customClass: "g-button--primary",
                    run: (ev, ctx) => {
                        this.addFunkceOK(ev);
                    }
                },
                actAddSpisUzel: {
                    caption: "jres:33000248", //RC 33000248 : Přidat
                    icon: "gi-plus",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.spisUzlyForm();
                    }
                },
                actEditSpisUzly: {
                    caption: "jres:32000120",
                    icon: "gi-pencil",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.editSpisUzly();
                    }
                },
                actAddSpisUzelOK: {
                    caption: "jres:33000243",
                    customClass: "g-button--primary",
                    run: (ev, ctx) => {
                        this.addSpisUzelOK(ev);
                    }
                },
                actCloseDialog: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        this.closeDialog(ev)
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actAddFunkce?.update({ enabled: editMode })
            this.cnt.actions.actEditFunkce?.update({ enabled: editMode })
            this.cnt.actions.actAddSpisUzel?.update({ enabled: editMode })
            this.cnt.actions.actEditSpisUzly?.update({ enabled: editMode })
        }

        createForm() {
            var _this = this;
            this.MakeSelectField("komb_sluzeb", Gordic.Prefabs.Select.wflcpos(), {
                multi: true,
                itemWidth: "",
                validators: [new Gordic.Validators.Required({ stopping: true }), this.createSpecialValidator()],
                model: function (op, dto, dtoOp) {
                    switch (op) {
                        case "apply":
                            if (dto["komb_sluzeb"]) {
                                var postSluzby = dto["komb_sluzeb"].split(',');
                                $(this).gfield("setValue", postSluzby.map(obj => ({ post_sluzba: obj })), { valid: false })
                            }
                            break;
                        case "collect":
                            if (_this.options.newRecord == true) {
                                var post_sluzby = $(this).gfield("getValue");
                                if (post_sluzby)
                                    if (post_sluzby.length > 1) {
                                        var komb_sluzeb = post_sluzby.map(obj => obj.post_sluzba);
                                        komb_sluzeb.sort((a, b) => { return a - b });
                                        dto["komb_sluzeb"] = komb_sluzeb.join(',');
                                    }
                            } else {
                                dto["komb_sluzeb"] = _this.data["komb_sluzeb"];
                            }
                            break;
                    }
                },
                change: (ev, dto) => {
                    if (this.options.newRecord == true) {
                        var generateNazev = "";
                        if (dto.value) {
                            if (Array.isArray(dto.value)) {
                                dto.value.forEach((item) => {
                                    if (item.post_sluzba_zkr) {
                                        generateNazev += item.post_sluzba_zkr + ",";
                                    }
                                })
                                generateNazev = generateNazev.slice(0, -1);
                            }
                        }
                        this.cnt.findFields("komb_sluzeb_txt").gfield("setValue", generateNazev);
                    }
                }
            })
            this.MakeField("komb_sluzeb_txt")
            this.MakeField("nazev")
            this.MakeField("filtr_format")
            this.form.addRow({ name: "row_vycet_uzel_funkce", label: "jres:33000234"}).addField("gradio", { //RC 33000234 : Přiřazení oblíbené položky
                name: "vycet_uzel_funkce",
                disabled: !this.editMode,
                itemClass: "w-12",
                radios: [
                    { value: 0, label: "jres:33000235" }, //RC 33000235 : Přiřadit oblíbené poštovní služby všem uživatelům
                    { value: 1, label: "jres:33000236" } //RC 33000236 : Přiřadit oblíbené poštovní služby pouze výčtem zadaným uzlům a funkcím
                ],
                change: (ev, obj) => {
                    if (this.options.newRecord == false) {
                        var tabManager = $(".gtabmanager");
                        if (obj.value == 1) {
                            tabManager.gtabmanager("visibleGroup", "_tab-funkce", true);
                            tabManager.gtabmanager("visibleGroup", "_tab-spis-uzel", true);
                            this.cnt.findFields("povolene_funkce", "povolene_spis_uzly").gfield("enable");
                        } else {
                            tabManager.gtabmanager("visibleGroup", "_tab-funkce", false);
                            tabManager.gtabmanager("visibleGroup", "_tab-spis-uzel", false);
                            tabManager.gtabmanager("setActive", "_tab-audit-pristupu");
                            this.cnt.findFields("povolene_funkce", "povolene_spis_uzly").gfield("disable");
                        }
                    }
                }
            })
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }

        // Validátor - kombinace musí obsahovat minimálně 2 služby
        private createSpecialValidator(): Gordic.Validators.Base {
            var validator = new Gordic.Validators.Base({ message: "jres:33000237" }); //RC 33000237 : Kombinace mus9 obsahovat minimálně dvě poštovní služby.
            validator.validate = (value, source) => {
                if (value.length > 1)
                    return true;
                return false;
            }
            validator.stopping = true;
            return validator;
        }

        private closeDialog(ev) {
            $.content(ev.target).close();
        }

        private funkceForm(inputData: Gordic.Adm.Interface.GWflvkslDtoExt | null = null) {
            var form = new Gordic.Forms.Form()
                .addRow("jres:32131054").addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                    name: "ixs",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    model: "model.ixs=value.ixs_fun;model.nazev=value.nazev_ref",
                    initialValue: (inputData != null) ? {
                        ixs_fun: inputData.ixs,
                        nazev_ref: inputData.nazev
                    } : null,
                    disabled: (inputData != null),
                    flag: "required"
                })
                .addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                    initialValue: (inputData != null) ? {
                        aktivita: inputData.aktivita,
                        aktivita_txt: inputData.aktivita_txt
                    } : null,
                    dropdown: true
                })

            this.cnt.dialogs.simpleForm("jres:33000247", form, null, { //RC 33000247 : Přidat navázanou funkci
                height: 250,
                commandBar: [
                    {
                        action: this.cnt.actions.actAddFunkceOK
                    },
                    {
                        action: this.cnt.actions.actCloseDialog
                    }
                ]
            }) 
        }

        private addFunkceOK(ev) {
            var cnt = $.content(ev.target);
            var values: Gordic.Adm.Interface.GWflvkslDtoExt = {};
            var gridData = this.gridFunkce.ggrid("getView").getDataRows(false, "data");
            if (cnt.findForms().gform("isValid")) {
                cnt.findFields().gfield("model", "collect", values);
                var findIndex = gridData.findIndex(e => e.ixs === values.ixs)
                if (findIndex == -1) {
                    values.ix = "SF";
                    gridData.push(values);
                } else {
                    gridData[findIndex].aktivita = values.aktivita;
                    gridData[findIndex].aktivita_txt = values.aktivita_txt;
                }
                this.gridFunkce.ggrid("setData", gridData);
                cnt.close();
            }
        }

        private editFunkce() {
            var selected = this.gridFunkce.ggrid("getSelection");
            if (selected.length > 0)
                this.gridFunkce.ggridroweditor("start");
        }

        createPovFunkceTab(panel: JQuery<HTMLElement>) {
            this.gridFunkce = $("<div>").appendTo(panel).gautofit({ resizersOnTab: false }).ggrid({
                defaultAction: this.cnt.actions.actEditFunkce,
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        name: "nazev",
                        caption: "jres:32131029",
                    })
                    .addTextColumn({
                        name: "aktivita_txt",
                        caption: "jres:32131030",
                        editor: {
                            widget: "gselectbox",
                            options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                                dropdown: true,
                                model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt"
                            })
                        }
                    })
            }).ggridroweditor({
                    beforeStart: (ev, info) => {
                        if (this.editMode == false)
                            ev.preventDefault();
                    }
            })
            if (this.data.povolene_funkce)
                this.gridFunkce.ggrid("setData", this.data.povolene_funkce);
        }

        private spisUzlyForm(inputData: Gordic.Adm.Interface.GWflvkslDtoExt | null = null) {
            var form = new Gordic.Forms.Form()
                .addRow("jres:29931149").addField("gselectbox", Gordic.Prefabs.Select.ginspod(), {
                    name: "ixs",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    model: "model.ixs=value.ixs_su;model.nazev=value.nazev",
                    initialValue: (inputData != null) ? {
                        ixs_su: inputData.ixs,
                        nazev: inputData.nazev
                    } : null,
                    disabled: (inputData != null),
                    flag: "required"
                })
                .addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.gincakt(), {
                    name: "aktivita",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt",
                    initialValue: (inputData != null) ? {
                        aktivita: inputData.aktivita,
                        aktivita_txt: inputData.aktivita_txt
                    } : null,
                    dropdown: true
                })

            this.cnt.dialogs.simpleForm("jres:33000249", form, null, { //RC 33000249 : Přidat navázaný spis. uzel
                height: 250,
                commandBar: [
                    {
                        action: this.cnt.actions.actAddSpisUzelOK
                    },
                    {
                        action: this.cnt.actions.actCloseDialog
                    }
                ]
            })
        }

        private addSpisUzelOK(ev) {
            var cnt = $.content(ev.target);
            var values: Gordic.Adm.Interface.GWflvkslDtoExt = {};
            var gridData = this.gridSpisUzly.ggrid("getView").getDataRows(false, "data");
            if (cnt.findForms().gform("isValid")) {
                cnt.findFields().gfield("model", "collect", values);
                var findIndex = gridData.findIndex(e => e.ixs === values.ixs)
                if (findIndex == -1) {
                    values.ix = "SS";
                    gridData.push(values);
                } else {
                    gridData[findIndex].aktivita = values.aktivita;
                    gridData[findIndex].aktivita_txt = values.aktivita_txt;
                }
                this.gridSpisUzly.ggrid("setData", gridData);
                cnt.close();
            }
        }

        private editSpisUzly() {
            var selected = this.gridSpisUzly.ggrid("getSelection");
            if (selected.length > 0)
                this.gridFunkce.ggridroweditor("start");
        }

        createPovSpisUzlyTab(panel: JQuery<HTMLElement>) {
            this.gridSpisUzly = $("<div>").appendTo(panel).gautofit({ resizersOnTab: false }).ggrid({
                defaultAction: this.cnt.actions.actEditFunkce,
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        name: "nazev",
                        caption: "jres:32131029",
                    })
                    .addTextColumn({
                        name: "aktivita_txt",
                        caption: "jres:32131030",
                        editor: {
                            widget: "gselectbox",
                            options: $.extend(Gordic.Prefabs.Select.gincakt(), {
                                dropdown: true,
                                model: "model.aktivita=value.aktivita;model.aktivita_txt=value.aktivita_txt"
                            })
                        }
                    })
            }).ggridroweditor({
                beforeStart: (ev, info) => {
                    if (this.editMode == false)
                        ev.preventDefault();
                }
            })
            if (this.data.povolene_spis_uzly)
                this.gridSpisUzly.ggrid("setData", this.data.povolene_spis_uzly);
        }
    }
}